module.exports = __webpack_public_path__ + "img/diagram-venn.220fc2d9.svg";